module.exports = __webpack_public_path__ + "img/03.f2b2e1bf.png";